import {defineStore} from 'pinia'
import {useApiRequestStore} from '@toolify/client/src/stores/ApiRequestStore/useApiRequestStore'
import {ICallBackgroundResponseInstance} from '@toolify/server/src/controllers/CallBackgroundController/types/ICallBackgroundResponseInstance'
import {
  IListCallBackgroundsRequestInterfaces,
} from '@toolify/server/src/controllers/CallBackgroundController/validators/ListCallBackgrounds/types/IListCallBackgroundsRequestInterfaces'
import {
  ICreateCallBackgroundRequestInterfaces,
} from '@toolify/server/src/controllers/CallBackgroundController/validators/CreateCallBackground/types/ICreateCallBackgroundRequestInterfaces'
import {
  IDeleteCallBackgroundRequestInterfaces,
} from '@toolify/server/src/controllers/CallBackgroundController/validators/DeleteCallBackground/types/IDeleteCallBackgroundRequestInterfaces'
import {IToJson} from '@toolify/client/src/types/IToJson'

export const useCallBackgroundApiStore = defineStore('callBackgroundApi', () => {
  const apiRequestStore = useApiRequestStore()

  async function listBackgrounds(): Promise<IToJson<ICallBackgroundResponseInstance>[]> {
    const {backgrounds} = await apiRequestStore.get<IListCallBackgroundsRequestInterfaces>('/me/call-backgrounds')
    return backgrounds
  }

  async function uploadBackground(file: File | Blob, name: string): Promise<IToJson<ICallBackgroundResponseInstance>> {
    const formData = new FormData()
    formData.append('file', file, name)
    const {background} = await apiRequestStore.post<ICreateCallBackgroundRequestInterfaces>('/me/call-backgrounds', {
      data: formData,
    })
    return background
  }

  async function deleteBackground(id: string): Promise<void> {
    await apiRequestStore.delete<IDeleteCallBackgroundRequestInterfaces>(`/me/call-backgrounds/${id}`)
  }

  return {
    listBackgrounds,
    uploadBackground,
    deleteBackground,
  }
})
